var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 0.333252C12.2802 0.333252 0.333496 12.2799 0.333496 26.9999C0.333496 41.7199 12.2802 53.6666 27.0002 53.6666C41.7202 53.6666 53.6668 41.7199 53.6668 26.9999C53.6668 12.2799 41.7202 0.333252 27.0002 0.333252ZM21.6668 36.3333V17.6666C21.6668 17.419 21.7359 17.1762 21.866 16.9656C21.9962 16.755 22.1823 16.5847 22.4039 16.474C22.6252 16.3633 22.8732 16.3164 23.1199 16.3386C23.3666 16.3609 23.602 16.4514 23.8002 16.5999L36.2535 25.9333C36.9735 26.4666 36.9735 27.5333 36.2535 28.0666L23.8002 37.3999C23.602 37.5485 23.3666 37.6389 23.1199 37.6613C22.8732 37.6834 22.6252 37.6365 22.4039 37.5258C22.1823 37.4151 21.9962 37.245 21.866 37.0343C21.7359 36.8237 21.6668 36.581 21.6668 36.3333Z",
    fill: "#F6F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a491669da562f0223eedfffe5618ca03.svg";
export { ForwardRef as ReactComponent };